// extracted by mini-css-extract-plugin
module.exports = {"iconsListItem":"PromoIconTCS_iconsListItem__lmdZo"};